
import { BlogPost } from "@/types/blog";
import { Heart } from "lucide-react";
import { content } from "./content";

export const KiGestuetzteWebentwicklung: BlogPost = {
  title: "KI-gestützte Webentwicklung: Meine Erfahrungen mit Lovable.dev",
  metaTitle: "KI-Webentwicklung: Erfahrungen mit Lovable.dev",
  excerpt: "Erfahrungsbericht: Wie moderne KI-Tools den Webentwicklungsprozess verändern und was ich bei der Erstellung dieser Website gelernt habe.",
  date: "08.03.2025",
  
  slug: "ki-gestuetzte-webentwicklung",
  imageUrl: "/images/blog/ki-webentwicklung.webp",
  category: "Technologie & Systeme",
  tags: ["KI", "Webentwicklung", "Lovable.dev", "Erfahrungsbericht", "Technologie"],
  author: "Jörg Hörmann",
  authorTitle: "Executive Coach & Finanzcoach",
  content
};
